<template>
  <!-- 
    Contenedor principal:
    - Muestra el color de fondo actual basado en la prop 'value'.
    - Le damos forma circular y tamaño fijo.
  -->
  <div 
    class="color-circle" 
    :style="{ backgroundColor: value }"
    title="Seleccionar color"
  >
    <!-- 
      Input nativo:
      - Es invisible gracias al CSS.
      - Al cambiar, emite el evento para actualizar el v-model.
    -->
    <input 
      type="color" 
      :value="value" 
      @input="updateColor"
    />
  </div>
</template>

<script>
export default {
  name: 'ColorCircle',
  // En Vue 2, v-model busca por defecto la prop 'value'
  props: {
    value: {
      type: String,
      default: '#000000'
    }
  },
  methods: {
    // Cuando el usuario elige un color, emitimos el valor al padre
    updateColor(event) {
      this.$emit('input', event.target.value);
    }
  }
}
</script>

<style lang="scss" scoped>
.color-circle {
  // Dimensiones solicitadas
  width: 40px;
  height: 40px;
  
  // Forma circular
  border-radius: 50%;
  
  // Borde sutil para que se vea si el color seleccionado es blanco
  border: 2px solid #e0e0e0;
  
  // Posicionamiento para contener el input hijo
  position: relative;
  overflow: hidden;
  cursor: pointer;
  
  // Sombra suave para darle relieve (opcional, pero se ve bien)
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  transition: transform 0.1s ease;

  &:active {
    transform: scale(0.95); // Efecto de pulsación al hacer clic
  }

  // Estilo del input nativo
  input[type="color"] {
    // Posicionamiento absoluto para cubrir todo el círculo
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    
    // Lo hacemos invisible, pero sigue siendo clickeable
    opacity: 0;
    cursor: pointer;
    
    // Eliminamos bordes y paddings nativos por si acaso
    padding: 0;
    margin: 0;
    border: none;
  }
}
</style>